import { render, staticRenderFns } from "./LogBookDefinitions.vue?vue&type=template&id=4a0c8600&scoped=true"
import script from "./LogBookDefinitions.vue?vue&type=script&lang=js"
export * from "./LogBookDefinitions.vue?vue&type=script&lang=js"
import style0 from "./LogBookDefinitions.vue?vue&type=style&index=0&id=4a0c8600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0c8600",
  null
  
)

export default component.exports